/**
 * services/mockModeBus.js
 * ──────────────────────────────────────────────────────────────────
 * Phase M6.0 (May 9, 2026) — global runtime flag set by the API
 * client whenever a backend response carries `_mock: true`. The
 * banner subscribes to render; the sonner monkey-patch reads it to
 * decide whether to prefix toasts with `[MOCK]`.
 *
 * No new state libs — plain EventTarget + module-scoped boolean.
 * Persists for the lifetime of the SPA session. Resets only when a
 * non-mock response arrives (which can never happen in mock mode,
 * so practically: this latches ON for the session in preview mode).
 */
const _bus = new EventTarget();
let _isMock = false;

export function getMockMode() { return _isMock; }

export function setMockMode(next) {
  const v = !!next;
  if (v === _isMock) return;
  _isMock = v;
  _bus.dispatchEvent(new CustomEvent('change', { detail: v }));
}

export function subscribeMockMode(fn) {
  const handler = (e) => fn(e.detail);
  _bus.addEventListener('change', handler);
  return () => _bus.removeEventListener('change', handler);
}

/**
 * Inspect an arbitrary axios response/error payload and update the
 * latched flag. Tolerant of every shape we see in this codebase
 * (`response.data._mock`, `error.response.data._mock`, the bare
 * unwrapped body, etc.).
 */
export function ingestResponse(payload) {
  try {
    if (!payload) return;
    if (payload._mock === true)                    { setMockMode(true); return; }
    if (payload?.data?._mock === true)             { setMockMode(true); return; }
    if (payload?.response?.data?._mock === true)   { setMockMode(true); return; }
  } catch (_) { /* ignore */ }
}
